"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var React = __importStar(require("react"));
var useOutsideClickNotifier_1 = require("../../library/hooks/useOutsideClickNotifier");
require("./tooltip.css");
var Tooltip = function (_a) {
    var activator = _a.activator, children = _a.children, appendClickListenerToElementRef = _a.appendClickListenerToElementRef, position = _a.position;
    var _b = React.useState(false), open = _b[0], setOpen = _b[1];
    var ref = React.useRef(null);
    var onTouchActivator = function () { return setOpen(!open); };
    var onMouseEnterActivator = function () { return setOpen(true); };
    var onMouseLeaveActivator = function () { return setOpen(false); };
    (0, useOutsideClickNotifier_1.useOutsideClickNotifier)(ref, open ? 'watch' : 'idle', function () {
        if (open) {
            onTouchActivator();
        }
    }, appendClickListenerToElementRef);
    return ((0, jsx_runtime_1.jsxs)("span", __assign({ ref: ref, className: (0, clsx_1.default)('tooltip', open ? 'open' : '') }, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ className: "tooltip-activator", onTouchStart: onTouchActivator, onMouseEnter: onMouseEnterActivator, onMouseLeave: onMouseLeaveActivator }, { children: activator })), (0, jsx_runtime_1.jsx)("div", __assign({ className: (0, clsx_1.default)('tooltip-content', "".concat(position)) }, { children: children }))] })));
};
exports.Tooltip = Tooltip;
//# sourceMappingURL=Tooltip.js.map